export const DEFAULT_ATTRS = {
    'v-if': true,
};
